import React from 'react';

import { Colors } from 'theme/colors';
import { FontSize } from 'theme/fonts';

import { Bubble } from 'components/base/bubble';

import { Bold, Light } from 'theme/text';

/**
 * Retrieves all matches the match the regex
 *
 * @param text - The text to match the regex
 */
function getMatches(text: string) {
  const regex = new RegExp("\\|([\\w\\s!#$%&'*+-/=?^_`{}~@]*)\\|", 'g');

  return text.match(regex);
}
/**
 * Renders a chat message bubble.
 *
 * @param props - Message Props.
 */
export function Message(props: Props) {
  const { showTip, text } = props;

  return (
    <Bubble showTip={showTip}>
      <MessageText text={text} />
    </Bubble>
  );
}
/**
 * Builds a message
 *
 * @param props - Render props
 */
function MessageText(props: Props) {
  const { text } = props;
  const matches = getMatches(text);
  const textItems = [];
  let currText = text;

  if (matches) {
    for (const match of matches) {
      if (currText) {
        const [first, rest] = currText.split(match);

        textItems.push(first);
        const boldText = match.replace(/\|/g, '');

        textItems.push(
          <Bold key={match} textAlign="center" fontSize={FontSize.Medium} color={Colors.black}>
            {boldText}
          </Bold>
        );
        currText = rest;
      }
    }
  } else {
    textItems.push(text);
  }

  return (
    <Light textAlign="center" fontSize={FontSize.Medium} color={Colors.black}>
      {textItems}
    </Light>
  );
}
/* Type definitions */
interface Props {
  /** Show a tip on top of a chat message */
  showTip?: boolean;
  /** The text to display inside the message. */
  text: string;
}
